import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  revService: [
    'runtimeConstant',
    '$q',
    '$http',
    '$filter',
    '$sce',
    '$state',
    '$rootScope',
    'signerInfoModel',
    'authService',
    'webApiSettings',
    'EDocumentStatus',
    'EFeatures',
    'OFFICE_TYPES',
    'IMG_TYPES',
    'TEXT_TYPES',
    'VIDEO_TYPES',
    'TIFF_TYPES',
    'EXT_ICONS',
    'OFFICE_COMPATIBLES',
    '$uibModal',
    'EAdminFeatures',
    'userModel',
    'validationService',
    function (
      runtimeConstant,
      $q,
      $http,
      $filter,
      $sce,
      $state,
      $rootScope,
      SignerInfo,
      authService,
      webApiSettings,
      EDocumentStatus,
      EFeatures,
      OFFICE_TYPES,
      IMG_TYPES,
      TEXT_TYPES,
      VIDEO_TYPES,
      TIFF_TYPES,
      EXT_ICONS,
      OFFICE_COMPATIBLES,
      uibModal,
      EAdminFeatures,
      User,
      validationService
    ) {
      var $scope = angular.element(document).scope();

      function revision(data, treeItem) {
        this.id = data.Id;
        this.guid = data.RowGuid;
        this.idAuthor = data.IdAuthor;
        this.idCompany = data.IdCompany;
        this.idDocumentType = data.IdDocumentType;
        this.idFolder = data.IdFolder;
        this.idStatus = data.IdStatus;
        this.revisionStatus = data.RevisionStatus ? data.RevisionStatus : 1;
        this.idPublickLinkUser = data.IdPublickLinkUser;
        this.publickLinkUser = data.PublickLinkUser;
        this.code = data.Code;
        this.title = data.Title;
        this.description = data.Description;
        this.revisionNumber = data.RevisionNumber !== undefined ? data.RevisionNumber : 0;
        this.date = data.Date;
        this.documentDate = data.DocumentDate;
        this.keywords = data.Keywords;
        this.PublicLinkDate = data.PublicLinkDate;
        this.extension = data.Extension;

        if (data.NextRevisionDate) this.nextRevisionDate = new Date(Date.parse(data.NextRevisionDate));

        if (data.NotificationDays) this.notificationDays = data.NotificationDays;

        this.size = data.Size;
        this.isFavorite = data.IsFavorite;
        this.numberOfPages = data.PageCount;
        this.propertiesIndexed = data.PropertiesIndexed;
        this.contentIndexed = data.ContentIndexed !== undefined ? data.ContentIndexed : null;
        this.features = data.Features;
        this.highlightFields = data.HighlightFields;
        this.revisionAdditionalFields = data.RevisionAdditionalFields;
        this.author = data.Author;
        this.folder = data.Folder;
        this.documentType = data.DocumentType;
        this.revisionCheckout = data.RevisionCheckout;
        this.sharedBy = data.SharedBy;
        this.hasLinkedDocuments = data.HasLinkedDocuments;
        this.trashDate = data.TrashDate;

        if (data.TrashUser) this.trashUser = new User(data.TrashUser);

        this.treeItem = treeItem;
        this.canShare = false;
        this.canSignDocument = false;
        this.canSignDocumentD4s = false;
        this.canShowReportDocument = false;
        this.canPublicLink = false;
        this.canReplace = false;
        this.canDelete = true;
        this.canProperties = false;
        this.canAuditDocuments = false;
        this.canConvertToPdf = false;
        this.canBecomeObsolete = true;
        this.canRestoreDocument = false;
        this.canFavorite = true;
        this.canUnfavorite = false;
        this.canNotifyUsers = false;
        this.canDownload = false;
        this.canView = true;
        this.hasViewPermission = true;
        this.canShowInFolder = false;
        this.canReplaceFile = false;
        this.isPublic = data.IsPublic;
        this.isSigned = data.IsSigned;
        this.signers = null;
        this.currentStepName = data.CurrentStepName !== undefined ? data.CurrentStepName : null;
        this.isHistory = data.IsHistory;
        this.idRevisionHistory = data.IdRevisionHistory;
        this.hasWorkflow = data.HasWorkflow;
        this.d4SignDocument = data.CurrentD4SignDocument;

        let existsSigns = false;

        if (data.Certificatas !== undefined) {
          data.Certificatas.forEach(function (cer) {
            if (
              cer.RevisionNumber === data.RevisionNumber
            ) {
              existsSigns = true;
            }
          });
        }

        this.certificataDocument = existsSigns ? data.Certificatas : [];

        this.updatePermissions();
        this.selected = false;
      }

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          var error = {
            statusCode: status,
            error: $filter('translate')('SERVER OFFLINE'),
            errorDescription: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };

          return error;
        }

        if (status !== 400) {
          var ex = {
            statusCode: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            errorDescription:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };

          return ex;
        }

        return err;
      }

      function loadSignersInfo(documentId, extension, inWorkflow, isHistory) {
        var deferred = $q.defer();

        var formUri =
          '?isPdf=' +
          (extension.toLowerCase() === 'pdf') +
          '&inWorkflow=' +
          inWorkflow +
          '&isHistory=' +
          (isHistory ? 'true' : 'false');
        $http
          .get(
            webApiSettings.apiServiceBaseUri +
            'revisions/file/signersInfo/' +
            documentId +
            formUri
          )
          .then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function updatePermissions() {
        this.canSignDocumentD4s =
          EAdminFeatures.CanD4SignIntegrate !== undefined
            ? this.checkPermission(EAdminFeatures.CanD4SignIntegrate)
            : false;
        this.canSignCertificate =
          EAdminFeatures.CanCertificataIntegrate !== undefined
            ? this.checkPermission(EAdminFeatures.CanCertificataIntegrate)
            : false;
        this.canShowReportDocument =
          EAdminFeatures.ViewReports !== false ? true : false;
        // se for autologin vai poder apenas visualizar e fazer download
        var isAutologin = authService.authentication.email === 'autologin';

        var canShareDoc =
          !isAutologin && this.checkPermission(EFeatures.SHARE_DOCUMENT);
        this.canPublicLink = canShareDoc;

        var canConvertToPdf =
          !isAutologin &&
          this.checkPermission(EFeatures.CONVERT_PDF) &&
          canValidateToConvert(this.extension);

        this.canConvertToPdf = canConvertToPdf;

        this.canShare =
          (this.sharedBy === undefined || this.sharedBy === null) &&
          this.idStatus !== EDocumentStatus.OBSOLETE &&
          canShareDoc;

        this.canSignDocument =
          this.idStatus === EDocumentStatus.ENABLED &&
          this.checkPermission(EAdminFeatures.CanD4SignIntegrate);
        this.canReplaceFile =
          this.checkPermission(EFeatures.REPLACE_FILE) &&
          this.idStatus === EDocumentStatus.ENABLED &&
          this.isPublic !== true;
        this.canDelete = this.checkPermission(EFeatures.DELETE_DOCUMENT);
        if (this.isDigitalization === true) {
          this.canProperties = true;
        } else {
          this.canProperties = this.checkPermission(EFeatures.CHANGE_PROPERTIES);
        }
        this.canAuditDocuments = this.checkPermission(EFeatures.DOCUMENT_AUDIT);
        this.canBecomeObsolete =
          (this.idStatus === EDocumentStatus.ENABLED ||
            this.idStatus === EDocumentStatus.WAITING_SIGNERS) &&
          this.checkPermission(EFeatures.BECOME_OBSOLETE) &&
          !isAutologin;
        this.canRestoreDocument =
          this.idStatus === EDocumentStatus.OBSOLETE &&
          this.checkPermission(EFeatures.BECOME_OBSOLETE) &&
          !isAutologin;
        this.canFavorite =
          !this.isFavorite &&
          this.checkPermission(EFeatures.DOWNLOAD) &&
          (this.sharedBy === undefined || this.sharedBy === null) &&
          !isAutologin;
        this.canUnfavorite =
          this.isFavorite &&
          (this.sharedBy === undefined || this.sharedBy === null) &&
          !isAutologin;

        this.canNotifyUsers = this.checkPermission(EFeatures.NOTIFY_USERS);
        this.canDownload = this.checkPermission(EFeatures.DOWNLOAD);
        this.canCheckout =
          this.checkPermission(EFeatures.CHECKOUT_CHECKIN) &&
          this.idStatus !== EDocumentStatus.OBSOLETE &&
          this.idStatus !== EDocumentStatus.IN_FLOW &&
          !(
            this.idStatus === 5 &&
            this.revisionCheckout &&
            this.revisionCheckout.IdUser !== authService.user.id
          );
        this.canCheckin =
          this.idStatus === EDocumentStatus.IN_CHECKOUT &&
          this.checkPermission(EFeatures.CHECKOUT_CHECKIN) &&
          this.revisionCheckout &&
          this.revisionCheckout.IdUser === authService.user.id;
        this.canCancelCheckout =
          this.checkPermission(EFeatures.CANCEL_CHECKOUT) &&
          this.idStatus === EDocumentStatus.IN_CHECKOUT &&
          this.revisionCheckout &&
          (this.revisionCheckout.IdUser === authService.user.id ||
            (authService.isAdmin() || authService.isSysAdmin()));
        this.canLinkDocument =
          this.checkPermission(EFeatures.LINK_FILE) && !this.hasLinkedDocuments;
        this.canCancelLinkDocument =
          this.checkPermission(EFeatures.LINK_FILE) && this.hasLinkedDocuments;
        this.canEditDocumentLink =
          this.checkPermission(EFeatures.LINK_FILE) && this.hasLinkedDocuments;
        var ext = this.extension.toLowerCase();
        if (ext.endsWith('p7s')) {
          ext = ext.split('.')[0];
        }
        this.canView =
          (OFFICE_TYPES.indexOf(ext) >= 0 ||
            IMG_TYPES.indexOf(ext) >= 0 ||
            TIFF_TYPES.indexOf(ext) >= 0 ||
            TEXT_TYPES.indexOf(ext) >= 0) &&
          this.checkPermission(EFeatures.VIEW_DOCUMENT);
        if (ext.endsWith('mp4')) {
          ext = ext.split('.')[0];
        }
        this.canMovie =
          VIDEO_TYPES.indexOf(ext) >= 0 &&
          this.checkPermission(EFeatures.VIEW_DOCUMENT);
        this.hasViewPermission = this.checkPermission(EFeatures.VIEW_DOCUMENT);
        this.hasViewPermission = this.checkPermission(EFeatures.VIEW_DOCUMENT);

        this.getCanShowInFolder();
      }

      function getCanShowInFolder() {
        if ($state.current.name !== 'home.folder') {
          let idUser;
          angular.forEach($rootScope, function (u, i) {
            if (i === 'user') {
              idUser = u.id;
            }
          });

          //this.treeItem !== undefined && this.treeItem !== null) {
          this.canShowInFolder =
            $state.current.name === 'home.shareds'
              ? !this.sharedBy || this.sharedBy.Id === idUser
              : true;
        } else {
          this.canShowInFolder = false;
        }
      }

      function checkPermission(permission) {
        if (authService.isAdmin()) {
          return true;
        }
        //Pega as features da pasta ou do documento quando estiver no favoritos, checkout ou pesquisa
        var features =
          this.features !== null && this.features !== undefined
            ? this.features
            : this.treeItem && this.treeItem.Features !== undefined
              ? this.treeItem.Features.split(',')
              : [];

        //verifica se é um array
        if (Array.isArray(permission)) {
          // verifica a permissão para cada item do array
          permission.forEach(function (p) {
            // Se pelo menos uma dos itens não estiver nas features retorna false
            if (features.filter((f) => f === p).length === 0) {
              return false;
            }
          });
        } else {
          //verifica se tem a permissão
          var Permission = features.filter((f) => f === permission).length > 0;
          return Permission;
        }
      }

      function getIcon() {
        var d4SignDocument = this.d4SignDocument;
        var ext = this.extension;
        var certificataDocument = this.certificataDocument;
        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext === 'webm' || ext === 'ogg' || ext === 'mp4') {
          var image =
            '<img src="/assets/images/file_extensions/video.png" style="width: 16px;" ></img>';
        }
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            ' ></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        if (d4SignDocument !== undefined) {
          if (d4SignDocument.Status !== 'Cancelado') {
            image +=
              '<img class="signed_doc" src="/assets/images/document_status/seal_parce.png" width="8px"></img>';
          }
          if (d4SignDocument.Status === 'Finalizado') {
            image +=
              '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
          }
        }

        if (certificataDocument !== undefined) {
          if (certificataDocument.length > 0) {
            if (certificataDocument[0].FinalizedAt === undefined) {
              image +=
                '<img class="signed_doc" src="/assets/images/document_status/seal_parce.png" width="8px"></img>';
            } else {
              image +=
                '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
            }
          }
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function getLargeIcon() {
        var ext = this.extension;
        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/large/default.png" width="32px"></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          image =
            '<img src="/assets/images/file_extensions/large/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/large/default.png\';" width="32px"></img>';
        }
        if (this.isSigned) {
          image +=
            '<img class="large_signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function isExpired() {
        var today = new Date();
        return (
          this.nextRevisionDate &&
          today.getTime() > this.nextRevisionDate.getTime()
        );
      }

      function validNotificationDays() {
        var today = new Date();

        if (
          this.nextRevisionDate !== null &&
          this.nextRevisionDate !== undefined
        ) {
          var diff =
            (this.nextRevisionDate.getTime() - today.getTime()) /
            1000 /
            60 /
            60 /
            24;
        }

        if (this.isExpired() === true) {
          delete this.notificationDay;
        }

        return this.notificationDays >= diff;
      }

      function isSelected() {
        if (arguments.length === 0) {
          return this.selected;
        }
      }

      function getDigitalizationStatus() {

        //
        // No backend existe um mapeamento do enum EDigitalizationStatus para EDocumentStatus.
        // Com esse mapeamento recebemos o idStatus desejado.
        //
        // 1 - EDigitalizationStatus.Waiting => EDocumentStatus.Enabled,
        // 2 - EDigitalizationStatus.Processing => EDocumentStatus.TrashCan,
        // 3 - EDigitalizationStatus.Processed => EDocumentStatus.InFlow,
        // 4 - EDigitalizationStatus.Creating => EDocumentStatus.Obsolete,
        // 5 - EDigitalizationStatus.Created => EDocumentStatus.InCheckout,
        // 6 - EDigitalizationStatus.Error => EDocumentStatus.WaitingFile,
        // 7 - EDigitalizationStatus.Updated => EDocumentStatus.InFlowInCheckout,
        //

        var status = '';

        switch (this.idStatus) {
          case 1:
            status = 'Aguardando';
            break;
          case 2:
            status = 'Processando';
            break;
          case 3:
            status = 'Processado';
            break;
          case 4:
            status = 'Criando revisão';
            break;
          case 5:
            status = 'Revisão criada';
            break;
          case 6:
            if (this.description && this.description.startsWith('CLASSIFICATION_PENDING:')) {
              var nome = this.description.replace('CLASSIFICATION_PENDING:', '');
              status = $sce.trustAsHtml(
                '<a href="javascript:void(0)" class="js-classify-pending digitalization-status-clickable" data-doc-id="' + this.id + '" title="Clique para classificar">' +
                '<i class="fa fa-pencil-square-o" style="color: orange; font-size: 16px; margin-right: 10px;"></i>' +
                'Classificação pendente: ' + nome +
                '</a>'
              );
            } else {
              status = $sce.trustAsHtml(
                '<span class="status-icon"><i class="fa fa-info-circle" style="color: orange; font-size: 20px; margin-right: 8px;"></i>Classificação pendente</span>'
              );
            }
            break;
          case 7:
            status = 'Atualizado';
            break;
        }

        return status;
      }

      function getStatusIcon() {
        var image = '';

        switch (this.idStatus) {
          case 1:
            if (this.isExpired()) {
              image =
                '<span class="status-icon"><i class="fa fa-clock-o"></i></span>'; //Expired
            } else {
              image = '';
            }
            break;
          case 3:
          case 7:
            image =
              '<span class="status-icon"><i class="fa fa-sitemap"></i></span>'; //InFlow
            break;
          case 4:
            image = '<i class="md md-backspace reverse"></i>'; //Completed
            break;
          case 5:
            if (this.revisionCheckout !== undefined) {
              var idUser = this.revisionCheckout.IdUser;

              if (authService.user.id === idUser) {
                image =
                  '<span class="status-icon text-info"><i class="fa fa-pencil"></i></span>'; //InCheckout
                break;
              }
            }

            image =
              '<span class="status-icon"><i class="fa fa-pencil"></i></span>'; //InCheckout another user
            break;
        }

        return $sce.trustAsHtml(image);
      }

      function getHighlights() {
        return $sce.trustAsHtml(this.highlightFields['all']);
      }

      function getStatus(isProperties) {
        switch (this.idStatus) {
          case 1:
            if (this.isExpired()) {
              return $filter('translate')('EXPIRED');
            } else if (isProperties) {
              return $filter('translate')('ENABLED');
            }
            break;
          case 2:
            return $filter('translate')('TRASH_CAN'); //TrashCan
          case 3:
            if (this.currentStepName) {
              return String.format(
                $filter('translate')('IN_FLOW CURRENT STEP'),
                [this.currentStepName]
              ); //InFlow
            } else if (this.idStatus === 3) {
              return $filter('translate')('IN_FLOW');
            }
            break;
          case 4:
            return $filter('translate')('OBSOLETE'); //Completed
          case 5:
            if (this.revisionCheckout.User !== undefined) {
              $scope.dateCheckout = this.revisionCheckout.Date;
              $scope.UserCheckout = this.revisionCheckout.User.Name;
              return $filter('translate')('IN_CHECKOUT'); //InCheckout
            }
          default:
            return '';
        }
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<mark><strong>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</strong></mark>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<mark><strong>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch { }
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function formatedTitle() {
        return this.title;
      }

      function formatedDescription() {
        var result = this.description ? this.description : '';
        return result;
      }

      function formatedDocumentType() {
        return $filter('truncate')(this.documentType.Name, 30, '...', true);
      }

      function formatedDate() {
        var result = new Date(Date.parse(this.date));
        return result.format('dd/mm/yyyy');
      }

      function formatedCreationDate() {
        if (!this.documentDate) return '-';
        var result = new Date(Date.parse(this.documentDate));
        return result.format('dd/mm/yyyy');
      }

      function formatedTrashDate() {
        var result = new Date(Date.parse(this.trashDate));
        return result.format('dd/mm/yyyy');
      }

      function tooltipTitle() {
        if (this.title.length > 60) {
          return this.title
            .toString()
            .replace(/<mark><strong>/g, '')
            .replace(/<\/strong><\/mark>/g, '');
        } else {
          return '';
        }
      }

      function tooltipDescription() {
        return this.description
          ? this.description
            .toString()
            .replace(/<mark><strong>/g, '')
            .replace(/<\/strong><\/mark>/g, '')
          : '';
      }

      function goToFolder() {
        var idFolder = this.idFolder;

        var btnGoToFolder;
        var btnImage = '/assets/images/tree_icons/Folder_Open.png';
        var btnStyle = 'cursor:pointer;';
        btnGoToFolder =
          '<a href="/#/folder/' +
          idFolder +
          '/1" style=' +
          btnStyle +
          ' data-toggle="tooltip" title="' +
          this.folder.Name +
          '" ><img src=' +
          btnImage +
          ' ></img></a>';
        return btnGoToFolder;
      }

      function formatedSize() {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var len = this.size;
        var order = 0;
        while (len >= 1024 && order + 1 < sizes.length) {
          order++;
          len = len / 1024;
        }

        if (len !== undefined && len !== null) {
          return len.toFixed(2).toString() + ' ' + sizes[order];
        }

        return '0 KB';
      }

      function signDocument() {
        if (!this.canSignDocument) {
          return false;
        }
        var revision = this;
        uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modules/signing/signDocumentPartial.html',
          controller: 'signDocumentsController',
          windowClass: 'sign-modal-window',
          resolve: {
            revisions: function () {
              return [revision];
            },
            inFlow: function () {
              return false;
            },
            sealData: function () {
              return "";
            },
          },
        });
      }

      function showInFolder() {
        if (!this.canShowInFolder) {
          return;
        }

        $scope.$broadcast('loadFolder', this.idFolder);
        //$state.go('home.folder', {id: this.idFolder, page: 1});
      }

      function properties(flow, guid) {
        var that = this;

        $scope.modalProperties = uibModal.open({
          animation: true,
          templateUrl: 'views/documents/properties/properties.html',
          controller: 'propertiesController',
          backdrop: 'static',
          keyboard: true,
          size: 'lg',
          resolve: {
            idRevision: function () {
              return that.id;
            },
            isDigitalization: function () {
              if (that.isDigitalization === true) {
                return true;
              }
              if ($state.current && $state.current.name === 'home.digitalizations') {
                return true;
              }
              return false;
            },
            insideFlow: function () {
              return flow ? true : false;
            },
            guid: function () {
              return guid || '';
            },
          },
        });
      }

      function updateProperties() {
        var deferred = $q.defer();
        var rev = JSON.parse(JSON.stringify(this));
        rev.idFolder = rev.folder.Id;
        rev.idDocumentType = rev.documentType.Id;
        rev.author = null;
        rev.folder = null;
        rev.documentType = null;
        rev.trashUser = null;
        rev.sharedBy = null;
        rev.keywords = Array.isArray(this.keywords) ? this.keywords.join(';') : null;

        if (this.revisionAdditionalFields) {
          var afs = [];
          for (var i = 0; i < this.revisionAdditionalFields.length; i++) {
            var a = this.revisionAdditionalFields[i];

            // Case DateTime remove offset
            if (a.value !== undefined && a.value !== null && a.fieldType === 6) {
              afs.push({
                IdRevision: this.id,
                IdAdditionalField: a.id,
                Value: new Date(a.value),
              });
            } else if (a.value !== undefined && a.value !== null) {
              afs.push({
                IdRevision: this.id,
                IdAdditionalField: a.id,
                Value: a.value,
              });
            }
          }

          rev.revisionAdditionalFields = afs;
        }

        if (rev.isDigitalization) {
          var createRevisionRequest = {
            IdDigitalization: rev.id,
            Title: rev.title,
            IdFolder: rev.idFolder,
            IdDocumentType: rev.idDocumentType,
          };

          const requiredParametersPopulated =
            createRevisionRequest.Title?.trim() !== '' &&
            [createRevisionRequest.IdDigitalization,
            createRevisionRequest.IdFolder,
            createRevisionRequest.IdDocumentType].every(id => id !== null && id !== 0);

          createRevisionRequest.Description = rev.description;
          createRevisionRequest.Keywords = rev.keywords;

          if (rev.revisionAdditionalFields) {
            createRevisionRequest.RevisionAdditionalFieldArray = JSON.stringify(rev.revisionAdditionalFields);
          }

          if (requiredParametersPopulated) {
            $http
              .post(
                `${webApiSettings.apiServiceBaseUri}digitalization/revision`,
                createRevisionRequest
              )
              .then((result) => {
                deferred.resolve(result.data || result);
              })
              .catch((err) => {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              });
          }
          else {
            var error = handleError('Existem campos não populados.', '999');
            deferred.reject(error);
          }
        }
        else {
          $http
            .put(`${webApiSettings.apiServiceBaseUri}revisions/updateproperties`, rev)
            .then((result) => {
              var r = resolveReferences(result.data);
              deferred.resolve(new revision(r));
            })
            .catch((err) => {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            });
        }

        return deferred.promise;
      }

      function canSaveAddFields() {
        var fieldToSave = 0;

        if (this.revisionAdditionalFields) {
          var fields = this.revisionAdditionalFields.filter(function (a) {
            switch (a.fieldType) {
              case 1:
                break;
              case 2:
              case 4:
                if (!(a.required || isNaN(a.value))) {
                  return a;
                }
                break;
              case 3:
                if (!a.required) {
                  return a;
                }
                if (a.validationType === 1 && a.value) {
                  //cpf
                  if (!validationService.validateCPF(a.value)) {
                    return a;
                  }
                }
                if (a.validationType === 2 && a.value) {
                  //cnpj
                  if (!validationService.validateCNPJ(a.value)) {
                    return a;
                  }
                }
                break;
              default:
                if (!a.required) {
                  return a;
                }
                break;
            }
          });

          fields.forEach(function (a) {
            if (a.required && isNaN(a.value)) {
              fieldToSave += 1;
            }

            return null;
          });
        }

        return fieldToSave === 0;
      }

      function loadSignersInfo(inWorkflow) {
        var rev = this;
        if (!this.signers) {
          loadSignersInfo(
            !rev.isHistory ? rev.id : rev.idRevisionHistory,
            rev.extension,
            inWorkflow,
            rev.isHistory
          ).then(
            function (data) {
              rev.signers = [];
              for (var i = 0; i < data.length; i++) {
                var obj = data[i];
                var si = new SignerInfo(obj);
                rev.signers.push(si);
              }
            },
            function () {
              rev.signers = undefined;
            }
          );
        }
      }

      function getPublicLink() {
        var revision = this;

        $rootScope.publicLinkModal = uibModal.open({
          animation: true,
          templateUrl: 'views/documents/public.link.html',
          controller: 'publicLinkController',
          backdrop: 'static',
          keyboard: true,
          size: 'md',
          resolve: {
            revision: function () {
              return revision;
            },
          },
        });
      }

      function postConvertToPdf() {
        var revision = this;

        $scope.messageTitle = $filter('translate')('DOCUMENT CONVERTER ?');
        $scope.messageDescription = $filter('translate')('CONVERTING TO PDF MAY CHANGE DOCUMENT FORMATING, SUCH AS FONTS, LINE BREAKS, AND TABLES. FOR YOUR SAFETY, REVIEW THE CONVERTED FILE BEFORE USING IT.');
        $scope.messageCancel = $filter('translate')('NO');
        $scope.messageForward = $filter('translate')('YES');

        $scope.modalQuestion = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'documentsController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            revisions: () => revision,
          },
        });
      }

      function canValidateToConvert(extension) {
        if (!extension)
          return false;

        var ext = String(extension)
          .toLowerCase()
          .replace(/^[\.]+/, '');

        if (!Array.isArray(OFFICE_COMPATIBLES)) return false;

        return OFFICE_COMPATIBLES.indexOf(ext) >= 0;
      }

      function run() {
        try {
          revision.prototype = {
            updatePermissions: logWrapper(
              updatePermissions,
              runtimeConstant.isDebugServicesInternals
            ),
            getCanShowInFolder: logWrapper(
              getCanShowInFolder,
              runtimeConstant.isDebugServicesInternals
            ),
            checkPermission: logWrapper(
              checkPermission,
              runtimeConstant.isDebugServicesInternals
            ),
            getIcon: logWrapper(
              getIcon,
              runtimeConstant.isDebugServicesInternals
            ),
            getLargeIcon: logWrapper(
              getLargeIcon,
              runtimeConstant.isDebugServicesInternals
            ),
            isExpired: logWrapper(
              isExpired,
              runtimeConstant.isDebugServicesInternals
            ),
            validNotificationDays: logWrapper(
              validNotificationDays,
              runtimeConstant.isDebugServicesInternals
            ),
            isSelected: logWrapper(
              isSelected,
              runtimeConstant.isDebugServicesInternals
            ),
            getStatusIcon: logWrapper(
              getStatusIcon,
              runtimeConstant.isDebugServicesInternals
            ),
            getDigitalizationStatus: logWrapper(
              getDigitalizationStatus,
              runtimeConstant.isDebugServicesInternals
            ),
            getHighlights: logWrapper(
              getHighlights,
              runtimeConstant.isDebugServicesInternals
            ),
            getStatus: logWrapper(
              getStatus,
              runtimeConstant.isDebugServicesInternals
            ),
            truncateText: logWrapper(
              truncateText,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedTitle: logWrapper(
              formatedTitle,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedDescription: logWrapper(
              formatedDescription,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedDocumentType: logWrapper(
              formatedDocumentType,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedDate: logWrapper(
              formatedDate,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedCreationDate: logWrapper(
              formatedCreationDate,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedTrashDate: logWrapper(
              formatedTrashDate,
              runtimeConstant.isDebugServicesInternals
            ),
            tooltipTitle: logWrapper(
              tooltipTitle,
              runtimeConstant.isDebugServicesInternals
            ),
            tooltipDescription: logWrapper(
              tooltipDescription,
              runtimeConstant.isDebugServicesInternals
            ),
            goToFolder: logWrapper(
              goToFolder,
              runtimeConstant.isDebugServicesInternals
            ),
            formatedSize: logWrapper(
              formatedSize,
              runtimeConstant.isDebugServicesInternals
            ),
            signDocument: logWrapper(
              signDocument,
              runtimeConstant.isDebugServicesInternals
            ),
            showInFolder: logWrapper(
              showInFolder,
              runtimeConstant.isDebugServicesInternals
            ),
            properties: logWrapper(
              properties,
              runtimeConstant.isDebugServicesInternals
            ),
            updateProperties: logWrapper(
              updateProperties,
              runtimeConstant.isDebugServicesInternals
            ),
            canSaveAddFields: logWrapper(
              canSaveAddFields,
              runtimeConstant.isDebugServicesInternals
            ),
            loadSignersInfo: logWrapper(
              loadSignersInfo,
              runtimeConstant.isDebugServicesInternals
            ),
            getPublicLink: logWrapper(
              getPublicLink,
              runtimeConstant.isDebugServicesInternals
            ),
            postConvertToPdf: logWrapper(
              postConvertToPdf,
              runtimeConstant.isDebugServicesInternals
            ),
            canValidateToConvert: logWrapper(
              canValidateToConvert,
              runtimeConstant.isDebugServicesInternals
            )
          };

          return revision;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
